module.exports = __webpack_public_path__ + "static/media/sick.35e264ae.jpg";